// extracted by mini-css-extract-plugin
export default {"mainChart":"Skeleton-module__mainChart--jf3OM","title":"Skeleton-module__title--VVWVl","subtitle":"Skeleton-module__subtitle--XS9dz"};